import React from 'react'

import Head from 'next/head'

import { APP_MAIN_PAGE_PREVIEW_IMG_URL } from 'src/utils/config'
import { UnknownObject } from 'src/utils/reactTypes'

export const BlogMeta: React.FC<UnknownObject> = () => {
  const title =
    'Insquad - Hire Startup Senior Developers | Scale your tech team 4x faster with remote talents'
  const metaDescription =
    'Insquad - Hire Startup Senior Developers | Articles on recruiting strategies, tech labor market, remote work, and much more'

  const previewTitle = 'Insquad - Hire Startup Senior Developers'
  const previewDescription =
    'Insquad - Hire Startup Senior Developers | Articles on recruiting strategies, tech labor market, remote work, and much more'

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={metaDescription} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={previewTitle} />
      <meta property="og:description" content={previewDescription} />
      <meta property="og:image" content={APP_MAIN_PAGE_PREVIEW_IMG_URL} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={previewTitle} />
      <meta name="twitter:description" content={previewDescription} />
      <meta name="twitter:image:src" content={APP_MAIN_PAGE_PREVIEW_IMG_URL} />
      <meta name="twitter:text:title" content={previewTitle} />
    </Head>
  )
}
